<template>
  <section class="hero" id="home">
    <div class="hero-image wrapper">
      <stars></stars>
      <rainbow></rainbow>
      <clouds></clouds>
      <img src="../../assets/unicorn.svg" class="icon" />
      <!-- <h1 class="slogan">Think Global. Act&#38;nbsp;Global.</h1> -->
    </div>
  </section>
</template>

<script>
import Rainbow from './Rainbow.vue'
import Stars from './Stars.vue'
import Clouds from './Clouds.vue'

export default {
  components: {
    Rainbow,
    Stars,
    Clouds
  }
}
</script>

<style lang="scss" scoped>
  .hero {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100vh;
    overflow: hidden;
  }

  h1.slogan {
    margin-top: 2em;
    color: #26245F;
    font-size: 2.7rem;
    padding: 0;
    margin: 0;
    position: absolute;
    top: 63%;
    z-index: 10;
    font-family: 'OpenSans-Bold', sans-serif;
    font-weight: 700;

    @media(max-width: 460px) {
      top: 70%;
      transform: scale(0.7);
    }

    @media(min-width: 461px) and (max-width: 500px) {
      top: 70%;
      transform: scale(0.7);
    }

    @media(min-width: 501px) and (max-width: 600px) {
      top: 75%;
      transform: scale(0.7);
    }

    @media(min-width: 601px) and (max-width: 900px) {
      top: 77%;
      transform: scale(0.8);
    }

    @media(min-width: 901px) and (max-width: 1200px) {
      top: 78%;
    }
  }

  .wrapper {
    height: 100%;
    width: 100%;
    left:0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    background: linear-gradient(124deg, #A0D29B, #A1D9EA, #E2A2C8);
    background-size: 1800% 1800%;
    animation: rainbow 18s ease infinite;
  }

  .icon {
    z-index: 20;
    position: absolute;
    top: 17%;

    @media(max-width: 599px) {
      top: 10%;
      transform: scale(0.8);
    }

    @media(min-width: 380) and (max-width: 600px) {
      top: 10%;
      transform: scale(0.8);
    }

    @media(min-width: 601px) and (max-width: 900px) {
      top: 15%;
      transform: scale(0.9);
    }
  }

  @keyframes rainbow {
      0%{background-position:0% 82%}
      50%{background-position:100% 19%}
      100%{background-position:0% 82%}
  }
</style>
